import React, { useState } from "react";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { toast } from "react-toastify";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import useFetch from "../../../../context/useFetch";

const ChangeOrderState = (props) => {
  let windowWidth = window.screen.width;
  const [openModal, setOpenModal] = useState(false);
  const createLog = useFetch({
    method: "post",
    url: `Order_Service/${props.selectedRow?.id}/create_order_log`,
    data: { state: "order_change_state" },
    argFunc: (res) => {},
    errMessage: (mess) => {},
  });
  const updateOrderApi = useFetch({
    method: "patch",
    url: `ProviderOrder_Service/${props.selectedRow?.id}/admin_revert_provider_order_from_onprogress_to_waiting`,
    trigger: false,
    data: { state: "waiting" },
    argFunc: (res) => {
      // toast.success("سفارش با موفقیت  منتقل شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setOpenModal(false);
      // createLog.reFetch();
      props.adminGetCustomerCurrentOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const provider_change_order_to_waiting = () => {
    updateOrderApi.reFetch();
  };

  return (
    <>
      <TableIconModal
        width="w-2/5"
        isRemove={true}
        removeText="آیا از انتقال سفارش به سفارش های جدید اطمینان دارید؟"
        icon={<ImportExportIcon />}
        openModal={openModal}
        setOpenModal={setOpenModal}
        handleRemoveOnClick={provider_change_order_to_waiting}
      ></TableIconModal>
    </>
  );
};

export default ChangeOrderState;
